<div
    class="flex flex-col w-full ~gap-4/8"
    data-aos="fade-up"
    date-aos-duration="500"
    gallerize="blog-post-gallery"
>
    @if (blogPostResource.isLoading()) {
        <ngx-skeleton-loader
            [theme]="{ height: '4rem', width: '40%' }"
        ></ngx-skeleton-loader>
        <div class="flex lg:flex-row flex-col ~gap-8/16">
            <ngx-skeleton-loader
                class="lg:w-2/3 h-full"
                [theme]="{ height: '20rem', width: '100%' }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
                class="lg:w-1/3 h-full"
                [theme]="{ height: '20rem', width: '100%' }"
            ></ngx-skeleton-loader>
        </div>
    } @else {
        @if (blogPostResource.hasValue()) {
            @let blogPost = blogPostResource.value().data[0];
            <h1 class="font-bold ~text-3xl/4xl">
                {{ blogPostResource.value()!.data[0].title }}
            </h1>
            @for (textImage of blogPost.textImages; track $index) {
                <div
                    class="flex lg:flex-row flex-col ~gap-8/16"
                    [ngClass]="{
                        'lg:flex-row-reverse': !textImage.isImageLeft,
                    }"
                >
                    <div class="flex flex-col gap-8 lg:w-2/3 h-fit">
                        <app-rich-text [data]="textImage.text"></app-rich-text>
                        @if (textImage.buttonText && textImage.buttonLink) {
                            <a
                                href="{{ textImage.buttonLink }}"
                                target="_blank"
                            >
                                <app-button size="small">{{
                                    textImage.buttonText
                                }}</app-button>
                            </a>
                        }
                        <svg
                            width="800"
                            height="800"
                            viewBox="0 0 24 24"
                            fill="none"
                            class="size-8 hover:scale-105 transition-transform cursor-pointer"
                            xmlns="http://www.w3.org/2000/svg"
                            (click)="
                                shareBlogPost(blogPostResource.value()!.data[0])
                            "
                        >
                            <path
                                d="M11.293 2.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L13 5.414V15a1 1 0 1 1-2 0V5.414L9.707 6.707a1 1 0 0 1-1.414-1.414zM4 11a2 2 0 0 1 2-2h2a1 1 0 0 1 0 2H6v9h12v-9h-2a1 1 0 1 1 0-2h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
                                class="fill-black"
                            />
                        </svg>
                    </div>
                    <img
                        src="{{
                            domHandler.getSmallestImageAsWebp(textImage.image)
                        }}"
                        [srcset]="
                            domHandler.generateSrcsetAsWebp(textImage.image)
                        "
                        [attr.imageSrc]="
                            domHandler.getLargestImage(textImage.image)
                        "
                        [attr.thumbSrc]="
                            domHandler.getSmallestImageAsWebp(textImage.image)
                        "
                        loading="lazy"
                        alt="{{ textImage.image.alternativeText }} text-image {{
                            $index
                        }}"
                        class="rounded-lg lg:w-1/3 h-80 max-h-96 object-cover"
                    />
                </div>
            }
            <div class="flex lg:flex-row flex-col justify-between ~gap-4/16">
                <app-rich-text [data]="data().infoText"></app-rich-text>
                @if (blogPost.nextBlogPost) {
                    <a
                        routerLink="/{{
                            languageService.getLanguageCode
                        }}/hof/blog-post/{{ blogPost.nextBlogPost.slug }}"
                        class="flex flex-col gap-2 p-4 border border-primary rounded-md w-fit h-fit text-nowrap"
                    >
                        {{ "blog.nextBlogPost" | translate }} >
                        <app-button size="small">{{
                            blogPost.nextBlogPost.title
                        }}</app-button>
                    </a>
                }
            </div>
        }
    }
</div>
